import { apiDaInscricao } from "../../../servicos/axios";

export type UsuarioPermissao = {
  id: number;
  nome: string;
  login: string;
  possuiPermissaoNoLocal: boolean;
};

export interface RespostaUsuariosComPermissao {
  modelo: UsuarioPermissao[];
  paginaAtual: number;
  quantidadePorPagina: number;
  totalDeRegistros: number;
  totalDePaginas: number;
}

export const buscarPermissoesUsuarios = async (
  idLocalDeAtendimento: string,
  nome: string = "",
  login: string = "",
  paginaAtual: number = 1
): Promise<RespostaUsuariosComPermissao> => {
  const response = await apiDaInscricao().get(
    `/LocalDeAtendimento/${idLocalDeAtendimento}/usuarios`,
    {
      params: {
        nome,
        login,
        paginaAtual,
      },
    }
  );
  return response.data;
};
